var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import classnames from 'classnames';
import Linkify from 'linkifyjs/react';
import { When } from '@alife/simple-ui';
import EmojiFace from '../../emoji-face';
import linkOptions from '../../../utils/link-options';
var defaultTemplateData = {
    txt: 'missing txt info',
    translateTxt: ''
};
function FlagTip(props) {
    var type = props.type;
    return (React.createElement("div", { className: classnames('flag-tip', "flag-" + type) }, type));
}
var flagTipMap = {
    1: React.createElement(FlagTip, { type: "q" }),
    2: React.createElement(FlagTip, { type: "a" }),
};
var TextCard = (function (_super) {
    __extends(TextCard, _super);
    function TextCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextCard.prototype.render = function () {
        var _a = this.props, templateData = _a.templateData, _b = _a.locale, locale = _b === void 0 ? {} : _b, displayTranslate = _a.displayTranslate, symbolReplace = _a.symbolReplace;
        var txt = templateData.txt, translateTxt = templateData.translateTxt, _c = templateData.flag, flag = _c === void 0 ? '' : _c;
        var flagTip = flagTipMap[flag];
        return (React.createElement("div", { className: "message-text-box" },
            React.createElement(Linkify, { tagName: "div", className: "lzd-message-text", options: linkOptions },
                React.createElement(EmojiFace, { symbolReplace: symbolReplace }, txt)),
            React.createElement(When, { condition: !!translateTxt && displayTranslate },
                React.createElement("div", { className: "box" },
                    React.createElement(Linkify, { tagName: "div", className: "lzd-message-text translation", options: linkOptions }, translateTxt || ''),
                    React.createElement("div", { className: "lzd-message-text tip" }, locale.translationTip || 'Alibaba Translation'))),
            flagTip));
    };
    TextCard.defaultProps = {
        templateData: defaultTemplateData
    };
    return TextCard;
}(React.Component));
export default TextCard;

//# sourceMappingURL=index.js.map
